var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCareerAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.75 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.24,39.67c.75-4.13,4.36-7.25,8.7-7.25h2.87c4.34,0,7.95,3.12,8.7,7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.26,27.54c0,2.7-2.19,4.88-4.88,4.88s-4.88-2.19-4.88-4.88,2.19-4.88,4.88-4.88,4.88,2.19,4.88,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.56,29.75c0,4.14-1.77,7.86-4.59,10.45-2.52,2.32-5.89,3.74-9.59,3.74s-7.07-1.41-9.59-3.74c-2.82-2.59-4.59-6.31-4.59-10.45,0-7.84,6.35-14.19,14.19-14.19s14.19,6.35,14.19,14.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.83,5.21c0-2.46-2-4.46-4.46-4.46s-4.46,2-4.46,4.46,2,4.46,4.46,4.46,4.46-2,4.46-4.46Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.37,
    y1: 9.67,
    x2: 26.37,
    y2: 15.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.91,54.29c0,2.46,2,4.46,4.46,4.46s4.46-2,4.46-4.46-2-4.46-4.46-4.46-4.46,2-4.46,4.46Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.37,
    y1: 49.83,
    x2: 26.37,
    y2: 43.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.79,21.17c2.12-1.25,2.84-3.98,1.59-6.11-1.25-2.12-3.98-2.84-6.11-1.59-2.12,1.25-2.84,3.98-1.59,6.11,1.25,2.12,3.98,2.84,6.11,1.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.69,
    y1: 19.59,
    x2: 38.61,
    y2: 22.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.95,38.33c-2.12,1.25-2.84,3.98-1.59,6.11,1.25,2.12,3.98,2.84,6.11,1.59,2.12-1.25,2.84-3.98,1.59-6.11-1.25-2.12-3.98-2.84-6.11-1.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.06,
    y1: 39.91,
    x2: 14.14,
    y2: 36.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.95,21.17c-2.12-1.25-2.84-3.98-1.59-6.11s3.98-2.84,6.11-1.59c2.12,1.25,2.84,3.98,1.59,6.11-1.25,2.12-3.98,2.84-6.11,1.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.06,
    y1: 19.59,
    x2: 14.14,
    y2: 22.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.79,38.33c2.12,1.25,2.84,3.98,1.59,6.11-1.25,2.12-3.98,2.84-6.11,1.59-2.12-1.25-2.84-3.98-1.59-6.11,1.25-2.12,3.98-2.84,6.11-1.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.69,
    y1: 39.91,
    x2: 38.61,
    y2: 36.93
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareerAssessment);
export default __webpack_public_path__ + "static/media/icon-career-assessment.aa3e5445c60c3b378465049b6c00c1a9.svg";
export { ForwardRef as ReactComponent };